import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.contabeleza.com.br";

export const DEFAULT_OG_IMAGE = `${BASE_URL}/images/og-contabeleza.jpg`;

const Seo = ({ title, description, image, jsonLd }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.title = title;
        const setAttr = (selector, value) => {
            const el = document.querySelector(selector);
            if (el) el.setAttribute("content", value);
        };
        setAttr('meta[name="description"]', description);
        setAttr('meta[property="og:title"]', title);
        setAttr('meta[property="og:description"]', description);
        setAttr('meta[property="og:url"]', `${BASE_URL}${pathname}`);
        setAttr('meta[property="og:image"]', image || DEFAULT_OG_IMAGE);
        setAttr('meta[name="twitter:title"]', title);
        setAttr('meta[name="twitter:description"]', description);
        setAttr('meta[name="twitter:image"]', image || DEFAULT_OG_IMAGE);
        setAttr('meta[name="twitter:card"]', "summary_large_image");
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.setAttribute("href", `${BASE_URL}${pathname}`);

        if (jsonLd) {
            document.getElementById("page-jsonld")?.remove();
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.id = "page-jsonld";
            script.textContent = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
        return () => {
            document.getElementById("page-jsonld")?.remove();
        };
    }, [title, description, image, pathname, jsonLd]);

    return null;
};

export default Seo;